import n from "moment";
import o from "../time/getTimeSpanParts.mjs";
function c(t, m) {
  const e = o(m);
  return n(t).hour(e.hours).minute(e.minutes).second(0).millisecond(0);
}
export {
  c as default
};
